import { DismissFilledIcon, Flex, Typography } from '@iheartjane/reefer';
import { pluralize } from '@iheartjane/utils';

import type { PageHeaderProps } from '../pageHeader/pageHeader';
import { PageHeader } from '../pageHeader/pageHeader';

export interface SearchPageHeaderProps extends Pick<
  PageHeaderProps,
  'breadcrumbCurrent' | 'breadcrumbs' | 'title'
> {
  onClearSearch: () => void;
  searchCount?: number;
  searchText?: string | null;
  searchType?: 'product' | 'brand' | string;
  userCityState?: string;
}
export const SearchPageHeader = ({
  breadcrumbCurrent,
  breadcrumbs,
  onClearSearch,
  searchCount,
  searchText = '',
  searchType = 'product',
  title,
  userCityState,
}: SearchPageHeaderProps) => (
  <PageHeader
    breadcrumbCurrent={breadcrumbCurrent}
    breadcrumbs={breadcrumbs}
    subtitle={
      searchCount
        ? `Found ${pluralize({ number: searchCount, noun: searchType })}${
            userCityState ? ` near ${userCityState}` : ''
          }`
        : undefined
    }
    title={
      searchText ? (
        <Flex alignItems="center">
          <Typography as="h1" branded variant="h2-semibold" mr={8}>
            Search for &#34;{searchText}&#34;
          </Typography>
          <DismissFilledIcon
            onClick={onClearSearch}
            altText="Clear search"
            size="sm"
          />
        </Flex>
      ) : (
        title
      )
    }
  />
);
